import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCommonConfig } from "../../../../../redux/actions";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  matchValidateVersi,
} from "../../../../../helpers/global_helper";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import infoIcon from "../../../../../assets/images/Icons/info_icon.svg";
import SilangPopup from "./SilangPopup";
import { formatPricewithdecimal, formatPrice } from "../../../../NumberFormat";
import { withTranslation } from "react-i18next";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { getUserBalance } from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";

const SilangVersiWap = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCommonConfig({ key: "gameType", value: "kembangkempis" }));
  }, []);

  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [totalData, setTotalData] = useState({});
  const [submitPopup, setSubmitPopup] = useState(false);
  const [submitResult, setSubmitResult] = useState({});
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);

  const [inputs, setInputs] = useState({
    kembangDepan: "",
    kembangTengah: "",
    kembangBelakang: "",
    kempisDepan: "",
    kempisTengah: "",
    kempisBelakang: "",
    kembarDepan: "",
    kembarTengah: "",
    kembarBelakang: "",
  });
  const [showTooltip, setShowTooltip] = useState(false);
  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const closeSubmitPopup = () => {
    setSubmitPopup(false);
    handleReset();
  };

  useEffect(() => {
    if (Object.keys(submitResult).length > 0) {
      setSubmitPopup(true);
    }
  }, [submitResult]);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    const intValue = parseInt(value);
    const minValue = betDiscount.showMin / 1000;
    const maxValue = betDiscount.showMax / 1000;

    // if (intValue < minValue) {
    //   setErrorMessage(`Minimal bet is ${minValue}`);
    //   setShowErrorPopup(true);
    //   return;
    // } else 
    if (intValue > maxValue) {
      setErrorMessage(props.t("The_bet_has_exceeded_the_maximum_bet"));
      setShowErrorPopup(true);
      return;
    }

    if (value === "" || (/^[0-9]*$/.test(value) && !isNaN(intValue))) {
      setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
    }
  }, []);

  useEffect(() => {
    handleReset();
  }, [gameId]);

  const handleReset = () => {
    setInputs({
      kembangDepan: "",
      kembangTengah: "",
      kembangBelakang: "",
      kempisDepan: "",
      kempisTengah: "",
      kempisBelakang: "",
      kembarDepan: "",
      kembarTengah: "",
      kembarBelakang: "",
    });
    setTotalData({});
    setTotalCountClick(false);
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const totalCount = (data) => {
    const {
      kembangDepan,
      kembangTengah,
      kembangBelakang,
      kempisDepan,
      kempisTengah,
      kempisBelakang,
      kembarDepan,
      kembarTengah,
      kembarBelakang,
    } = inputs;
    if (
      kembangDepan === "" &&
      kembangTengah === "" &&
      kembangBelakang === "" &&
      kempisDepan === "" &&
      kempisTengah === "" &&
      kempisBelakang === "" &&
      kembarDepan === "" &&
      kembarTengah === "" &&
      kembarBelakang === ""
    ) {
      showMessage(props.t("guess_bet_wrong"), "error", "error");
      return;
    }
    data = {
      gameId: gameId,
      gameType: "kembangkempis",
      databet_kembang_depan: kembangDepan,
      databet_kembang_tengah: kembangTengah,
      databet_kembang_belakang: kembangBelakang,
      databet_kempis_depan: kempisDepan,
      databet_kempis_tengah: kempisTengah,
      databet_kempis_belakang: kempisBelakang,
      databet_kembar_depan: kembarDepan,
      databet_kembar_tengah: kembarTengah,
      databet_kembar_belakang: kembarBelakang,
      fastbet: true,
      multiple: betDiscount.showMultiple
    };

    let matchValidate = matchValidateVersi(gameType, data);
    if (matchValidate) {
      if (matchValidate == "format_input") {
        setErrorMessage(props.t(matchValidate));
        setShowErrorPopup(true);
        return;
      } else {
        setErrorMessage(props.t("format_input_on") + " " + matchValidate);
        setShowErrorPopup(true);
        return;
      }
    }

    makeAjax(url.TOGEL_API.processDataBet, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }

        if (response.code !== "validation_error") {
          showMessage(response.code, "error", "error");
          setTotalData({});
          return;
        }
        showMessage(response.code, "error", "error");
        setTotalData({});
        return;
      }
      setTotalData(response.data);
      setTotalCountClick(true);
    });
  };

  const submitProcess = (data) => {
    if (totalCountClick) {
      setShowConfirmationPopup(true);
    } else {
      const {
        kembangDepan,
        kembangTengah,
        kembangBelakang,
        kempisDepan,
        kempisTengah,
        kempisBelakang,
        kembarDepan,
        kembarTengah,
        kembarBelakang,
      } = inputs;
      if (
        kembangDepan === "" &&
        kembangTengah === "" &&
        kembangBelakang === "" &&
        kempisDepan === "" &&
        kempisTengah === "" &&
        kempisBelakang === "" &&
        kembarDepan === "" &&
        kembarTengah === "" &&
        kembarBelakang === ""
      ) {
        showMessage(props.t("guess_bet_wrong"), "error", "error");
        return;
      }
      data = {
        gameId: gameId,
        gameType: "kembangkempis",
        databet_kembang_depan: kembangDepan,
        databet_kembang_tengah: kembangTengah,
        databet_kembang_belakang: kembangBelakang,
        databet_kempis_depan: kempisDepan,
        databet_kempis_tengah: kempisTengah,
        databet_kempis_belakang: kempisBelakang,
        databet_kembar_depan: kembarDepan,
        databet_kembar_tengah: kembarTengah,
        databet_kembar_belakang: kembarBelakang,
        fastbet: true,
        multiple: betDiscount.showMultiple
      };

      let matchValidate = matchValidateVersi(gameType, data);
      if (matchValidate) {
        if (matchValidate == "format_input") {
          setErrorMessage(props.t(matchValidate));
          setShowErrorPopup(true);
          return;
        } else {
          setErrorMessage(props.t("format_input_on") + " " + matchValidate);
          setShowErrorPopup(true);
          return;
        }
      }

      makeAjax(url.TOGEL_API.processDataBet, data).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
            setShowConfirmationPopup(false);
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            return;
          }
          if (response.code === "market_close_err") {
            setShowConfirmationPopup(false);
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            return;
          }

          if (response.code !== "validation_error") {
            showMessage(response.code, "error", "error");
            setTotalData({});
            return;
          }
          showMessage(response.code, "error", "error");
          setTotalData({});
          return;
        }
        setTotalData(response.data);
      });
      setShowConfirmationPopup(true);
    }
  };

  const submitKembang = (data) => {
    setShowConfirmationPopup(false);
    const dataangka = [];
    const {
      kembangDepan,
      kembangTengah,
      kembangBelakang,
      kempisDepan,
      kempisTengah,
      kempisBelakang,
      kembarDepan,
      kembarTengah,
      kembarBelakang,
    } = inputs;

    const checkAndPush = (condition, label, value) => {
      if (condition) {
        dataangka.push([label, value * betDiscount.showMultiple, "success"]);
      } else {
        dataangka.push(["", "", "null"]);
      }
    };
    checkAndPush(
      kembangDepan != 0 && kembangDepan != "",
      "Kembang-Depan",
      kembangDepan
    );
    checkAndPush(
      kembangTengah != 0 && kembangTengah != "",
      "Kembang-Tengah",
      kembangTengah
    );
    checkAndPush(
      kembangBelakang != 0 && kembangBelakang != "",
      "Kembang-Belakang",
      kembangBelakang
    );
    checkAndPush(
      kempisDepan != 0 && kempisDepan != "",
      "Kempis-Depan",
      kempisDepan
    );
    checkAndPush(
      kempisTengah != 0 && kempisTengah != "",
      "Kempis-Tengah",
      kempisTengah
    );
    checkAndPush(
      kempisBelakang != 0 && kempisBelakang != "",
      "Kempis-Belakang",
      kempisBelakang
    );
    checkAndPush(
      kembarDepan != 0 && kembarDepan != "",
      "Kembar-Depan",
      kembarDepan
    );
    checkAndPush(
      kembarTengah != 0 && kembarTengah != "",
      "Kembar-Tengah",
      kembarTengah
    );
    checkAndPush(
      kembarBelakang != 0 && kembarBelakang != "",
      "Kembar-Belakang",
      kembarBelakang
    );

    data = {
      gameId: gameId,
      dataangka: dataangka,
      gameType: "kembangkempis",
      action: "process",
      allowPartner: "allowPartner",
      betTogelAuth: "betTogelAuth",
      fastbet: true,
      multiple: betDiscount.showMultiple
    };

    makeAjax(url.TOGEL_API.processAltTogel, data).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }

        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code))
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data found", "error", "error");
        return;
      }
      setSubmitResult(response.data);
      dispatch(getUserBalance());
    });
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* --- Rules ---  */}
          <div className="rules_container">
            <div>
              <p>{props.t('silang_kembang_kembang_text')}</p>
              <p>Format Tarun: Nominal taruhan sesuai konversi</p>
              <p>Conoth Penulisan: 1 pada Panel</p>
            </div>
            <div className="rules_conversion">
              <p>
                Konversi <br /> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          {/* --- Rules ---  */}
          <div class="versicontainer_input">
            <div class="versicontainer_inputleft">
              <label for="input_left">Kembang Depan</label>
              <input
                type="text"
                name="kembangDepan"
                value={inputs.kembangDepan}
                onChange={handleInputChange}
                placeholder="Bet"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
            <div class="versicontainer_inputright">
              <label for="input_right">Kempis Depan</label>
              <input
                type="text"
                name="kempisDepan"
                value={inputs.kempisDepan}
                onChange={handleInputChange}
                placeholder="Bet"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
          </div>

          {/* 2nd row */}
          <div class="versicontainer_input">
            <div class="versicontainer_inputleft">
              <label for="input_left">Kembang Tengah</label>
              <input
                type="text"
                name="kembangTengah"
                value={inputs.kembangTengah}
                onChange={handleInputChange}
                placeholder="Bet"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
            <div class="versicontainer_inputright">
              <label for="input_right">Kempis Tengah</label>
              <input
                type="text"
                name="kempisTengah"
                value={inputs.kempisTengah}
                onChange={handleInputChange}
                placeholder="Bet"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
          </div>

          {/* 3rd row */}
          <div class="versicontainer_input">
            <div class="versicontainer_inputleft">
              <label for="input_left">Kembang Belakang</label>
              <input
                type="text"
                name="kembangBelakang"
                value={inputs.kembangBelakang}
                onChange={handleInputChange}
                placeholder="Bet"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
            <div class="versicontainer_inputright">
              <label for="input_right">Kempis Belakang</label>
              <input
                type="text"
                name="kempisBelakang"
                value={inputs.kempisBelakang}
                onChange={handleInputChange}
                placeholder="Bet"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
          </div>

          {/* 4rd row */}
          <div class="versicontainer_input">
            <div class="versicontainer_inputleft">
              <label for="input_left">Kembar Depan</label>
              <input
                type="text"
                name="kembarDepan"
                value={inputs.kembarDepan}
                onChange={handleInputChange}
                placeholder="Bet"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
            <div class="versicontainer_inputright">{/* empty div */}</div>
          </div>

          {/* 5th row */}
          <div class="versicontainer_input">
            <div class="versicontainer_inputleft">
              <label for="input_left">Kembar Tengah</label>
              <input
                type="text"
                name="kembarTengah"
                value={inputs.kembarTengah}
                onChange={handleInputChange}
                placeholder="Bet"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
            <div class="versicontainer_inputright">{/* empty div */}</div>
          </div>

          {/* 6th row */}
          <div class="versicontainer_input">
            <div class="versicontainer_inputleft">
              <label for="input_left">Kembar Belakang</label>
              <input
                type="text"
                name="kembarBelakang"
                value={inputs.kembarBelakang}
                onChange={handleInputChange}
                placeholder="Bet"
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
            <div class="versicontainer_inputright">{/* empty div */}</div>
          </div>

          {/* 1 */}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total {props.t("line")}</span> :{" "}
                  {totalData.line ? totalData.line : "-"}
                </p>
                <p>
                  <span>Total {props.t("purchases")}</span> :{" "}
                  {totalData.tover ? formatPrice(totalData.tover) : "-"}
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>Total {props.t("discount")}</span>:{" "}
                  {totalData.disc
                    ? formatPricewithdecimal(totalData.disc)
                    : "-"}
                </p>
                <p>
                  <span>Total {props.t("payment")}</span> :{" "}
                  {totalData.pay ? formatPricewithdecimal(totalData.pay) : "-"}
                </p>
              </div>
              <div className="info_icon">
                <img src={infoIcon} alt="" onClick={toggleTooltip} />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format Taruhan
                      </span>
                      <span className="tooltip_content">
                        bet kembar, kempis, depan, tengah, belakang
                      </span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>

          {/* button*/}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={totalCount}>{props.t("count_total")}</button>
              </div>
              <div className="button_right">
                <button className="reset" onClick={handleReset}>
                  {props.t('reset')}
                </button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              <button onClick={submitProcess}>{props.t('submit')}</button>
            </div>
          </div>
        </>
      )}

      {
        /*---error popup --*/
        showErrorPopup && (
          <ErrorInnerPopup
            modalTitle={""}
            modalHeader={true}
            onCloseModal={() => setShowErrorPopup(false)}
          >
            <ErrorPopup
              message={errMessage}
              onClose={() => setShowErrorPopup(false)}
            />
          </ErrorInnerPopup>
        )
      }

      {submitPopup && (
        <SilangPopup onClose={closeSubmitPopup} submitResult={submitResult} />
      )}

      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={hanldeConfirmationPopupClose}
          submitProcessOk={submitKembang}
        />
      )}

      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCanclledPopup(false)} />
      )}
    </div>
  );
};

export default withTranslation()(SilangVersiWap);
